import React from 'react'
import { Link, type LinkProps } from 'react-router'
import { type SetOptional } from 'type-fest'

import { useLogEvent } from '~/hooks/useLogEvent'
import { exists } from '~/utils'

export type BetterLinkProps = {
  'data-testid'?: string
  logEventName?: string
} & (LinkProps | SetOptional<LinkProps, 'to'>)

export const BetterLink = ({
  children,
  'data-testid': dataTestId = 'components-features-better-link',
  logEventName,
  onClick,
  to,
  ...rest
}: BetterLinkProps) => {
  const logEvent = useLogEvent()
  const handleClick = React.useCallback<EH<LinkProps, 'onClick'>>(
    (...args) => {
      if (exists(logEventName)) {
        logEvent(logEventName)
      }
      onClick?.(...args)
    },
    [logEvent, logEventName, onClick],
  )

  if (exists(to)) {
    return (
      <Link data-testid={dataTestId} to={to} onClick={handleClick} {...rest}>
        {children}
      </Link>
    )
  }

  return <>{children}</>
}
